import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";

import { postApi, baseURL } from "../components/Utility";
import {
  action,
  computed,
  makeObservable,
  observable,
  autorun,
  runInAction,
  observe,
} from "mobx";
import { act } from "react-dom/test-utils";
import config from "../config";
import { message } from 'antd';


class DriverScoreReportStore {
  driverScoreReport = [];
  remaning_driverId = ""
  last_record_timestamp = ""
  remaning_vehicleId = ""
  total = 0;
  loading = false;
  rootStore;
  getVehicles = []
  pythonReportMessage = false

  constructor(rootStore) {
    makeObservable(this, {
      driverScoreReport: observable,
      remaning_driverId: observable,
      remaning_vehicleId: observable,
      last_record_timestamp: observable,
      total: observable,
      loading: observable,
      getVehiclesByCompanyId: action,
      loadData: action,
      pythonReportMessage: observable
    });
    this.rootStore = rootStore;
  }

  async loadData({ companyId, driverId, vehicleId, filterBy, offset, limit, returnType, reportType, pageNo, fromDate, toDate, }) {
    // console.log("vehicle list",returnType)
    this.loading = true;

    if (reportType == 1) {
      var postData = {
        companyId: companyId,
        driverId: driverId,
        vehicleId: vehicleId,
        filterBy: filterBy,
        // fromDate: fromDate,
        // toDate: toDate,

        fromMonth: fromDate,
        toMonth: toDate,
        reportType: reportType,
        offset: offset,
        limit: limit,
        page: pageNo,

      };
    }
    if (reportType == 3 || reportType == 2) {
      var postData = {
        companyId: companyId,
        driverId: driverId,
        vehicleId: vehicleId,
        filterBy: filterBy,
        // fromDate: fromDate,
        // toDate: toDate,

        fromDate: fromDate,
        toDate: toDate,
        reportType: reportType,
        offset: offset,
        limit: limit,
        page: pageNo,
      };
    }

    if (config.pythonReport === 1) {

      if (offset === 0) {

        postData['last_record_timestamp'] = ""
        postData['remaning_driverId'] = ""
        postData['remaning_vehicleId'] = ""
      } else {
        postData['last_record_timestamp'] = this.last_record_timestamp
        postData['remaning_driverId'] = this.remaning_driverId
        postData['remaning_vehicleId'] = this.remaning_vehicleId
      }

      var response = await postApi.getClient('report').post("/report/driverscore", postData);
      this.total = 500

    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      var response = await postApi.getClient().post("index.php?c=driver&a=getdriverscorelist", "postData=" + base64Input);
      this.total = parseInt(response?.data?.data?.TotalCount);
    }

    if (config.pythonReport === 1) {
      this.last_record_timestamp = response?.data?.data?.last_record_timestamp
      this.remaning_driverId = response?.data?.data?.remaning_driverId
      this.remaning_vehicleId = response?.data?.data?.remaning_vehicleId
    }

    // console.log(response?.data?.data);
    this.driverScoreReport = response?.data?.data?.driverscore;
    this.loading = false;
  }

  async getVehiclesByCompanyId({ companyId }) {
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);
    console.log(response, "post");
    this.getVehicles = response?.data?.data;
    return response?.data?.data;
  }
  async exportExcel(getData) {
    // console.log("getData", getData);
    if (config.pythonReport === 1) {

      getData = { ...getData, language: "english" }
      // getData = { ...getData, companyId: 118 }
      // getData = { ...getData, driverName: [2142],fromDate: "2023-01-01 00:00:00", toDate: "2023-01-07 12:54:00" }
      try {

        await postApi.getClient("report").post("/report/driverscore/download/excel", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
        // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);

      } catch (error) {
        message.error("Failed to download the report. Please try again.")
      }

    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=driver&a=exportDriverscoreExcel&cid=" +
        getData.companyId +

        "&did=" +
        getData.Driver +
        "&rt=" +
        getData.reportType +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }

  }
  async exportpdf(getData) {

    if (config.pythonReport === 1) {

      getData = { ...getData, language: "english" }
      // getData = { ...getData, companyId: 118 }
      // getData = { ...getData, driverName: [2142],fromDate: "2023-01-01 00:00:00", toDate: "2023-01-07 12:54:00" }
      try {

        await postApi.getClient("report").post("/report/driverscore/download/pdf", getData, {
          responseType: "blob",
        });
        this.pythonReportMessage = true;
        // await message.success("The report will be generated shortly. You can check its status in the pending report list.", 2);

      } catch (error) {
        this.pythonReportMessage = false;
        message.error("Failed to download the report. Please try again.")
      }

    } else {
      let lang = "english";
      window.location.href =
        baseURL +
        "index.php?c=driver&a=exportDriverscorePdf&cid=" +
        getData.companyId +
        "&did=" +
        getData.Driver +
        "&rt=" +
        getData.reportType +
        "&fD=" +
        getData.fromDate +
        "&tD=" +
        getData.toDate +
        "&colList=" +
        getData.colList +
        "&language=" +
        lang;
    }

  }
  async exportcsv(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=driver&a=exportDriverscoreCsv&cid=" +
      getData.companyId +
      "&did=" +
      getData.Driver +
      "&rt=" +
      getData.reportType +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
  async exportxml(getData) {
    let lang = "english";
    window.location.href =
      baseURL +
      "index.php?c=driver&a=exportDriverscoreXml&cid=" +
      getData.companyId +
      "&did=" +
      getData.Driver +
      "&rt=" +
      getData.reportType +
      "&fD=" +
      getData.fromDate +
      "&tD=" +
      getData.toDate +
      "&colList=" +
      getData.colList +
      "&language=" +
      lang;
  }
}

export default DriverScoreReportStore;
